export default __webpack_public_path__ + "static/media/Image-1.f5841879.png";